export let getComponent = (type) => {
    switch (type) {
    case 'item':
        return import(
            /* webpackChunkName: "lq-item-widget" */
            /* webpackMode: "lazy" */
            '@/components/item'
        );
    default:
        return import(
            /* webpackChunkName: "lq-list-widget" */
            /* webpackMode: "lazy" */
            '@/components/list'
        );
    }
};



// WEBPACK FOOTER //
// ./src/app/widget.js